import { Icon } from '@types';

export const Email = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 76.93 76.12"
		>
			<defs>
				<style>
					{
						'.cls-email,.cls-email-2{fill:#fff;}.cls-email-2,.cls-email-3{stroke:#2e2d2c;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-email-3{fill:none;}'
					}
				</style>
			</defs>
			<path
				className="cls-email-3"
				d="M40.26,1.57c-.99-.76-2.6-.76-3.58,0L2.79,27.87c-.99,.76-1.79,2.41-1.79,3.66v41.32c0,1.25,1.02,2.27,2.27,2.27H73.67c1.25,0,2.27-1.02,2.27-2.27V31.53c0-1.25-.81-2.89-1.79-3.66L40.26,1.57Z"
			/>
			<polyline className="cls-email-2" points="12.06 38.4 12.06 12.98 64.88 12.98 64.88 38.4" />
			<path
				className="cls-email-3"
				d="M74.89,30.18l-34.69,29.12c-.96,.8-2.52,.8-3.47,0L1.67,29.86"
			/>
			<g>
				<path
					className="cls-email"
					d="M3.27,75.12c-1.25,0-1.47-.64-.5-1.43l33.94-27.44c.97-.78,2.56-.78,3.53,0l33.94,27.44c.97,.78,.74,1.43-.5,1.43H3.27Z"
				/>
				<path
					className="cls-email-3"
					d="M3.27,75.12c-1.25,0-1.47-.64-.5-1.43l33.94-27.44c.97-.78,2.56-.78,3.53,0l33.94,27.44c.97,.78,.74,1.43-.5,1.43H3.27Z"
				/>
			</g>
			<g>
				<path
					className="cls-email-3"
					d="M43.54,29.86c0,2.8-2.27,5.08-5.08,5.08s-5.08-2.27-5.08-5.08,2.27-5.08,5.08-5.08,5.08,2.27,5.08,5.08Z"
				/>
				<path
					className="cls-email-3"
					d="M49.15,29.86c0,3.53-1.07,5.08-2.8,5.08-1.91,0-2.8-1.55-2.8-5.08"
				/>
				<path
					className="cls-email-3"
					d="M42.63,39.71c-1.28,.54-2.68,.84-4.16,.84s-2.88-.3-4.16-.84-2.43-1.32-3.4-2.29c-.97-.97-1.75-2.12-2.29-3.4-.54-1.28-.84-2.68-.84-4.16s.3-2.88,.84-4.16c.54-1.28,1.32-2.43,2.29-3.4,.97-.97,2.12-1.75,3.4-2.29,1.28-.54,2.68-.84,4.16-.84s2.88,.3,4.16,.84c1.28,.54,2.43,1.32,3.4,2.29,.97,.97,1.75,2.12,2.29,3.4,.54,1.28,.84,2.68,.84,4.16"
				/>
			</g>
		</svg>
	);
};
